import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { BACKEND_BASE_URL, IResponseError, serialize } from "@/services";
import { ICashOrderDTO } from "@/entities";
import { IApprovalsParams, IApprovalsService } from "./approvals.types";

export class ApprovalsService implements IApprovalsService {
  async getOrders(params: IApprovalsParams): Promise<ICashOrderDTO[] | undefined> {
    const { response, error } = await handleResponse<ICashOrderDTO[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order`, {
        params,
        paramsSerializer: (p) => serialize(p),
      })
    );

    if (error) {
      return undefined;
    }

    return response?.data;
  }
}
